import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class MundialVote extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "teamPot1Id", Model.attribute('teamPot1Id'));
    _defineProperty(this, "teamPot2Id", Model.attribute('teamPot2Id'));
    _defineProperty(this, "teamPot3Id", Model.attribute('teamPot3Id'));
    _defineProperty(this, "teamPot4Id", Model.attribute('teamPot4Id'));
    _defineProperty(this, "sameVoteCount", Model.attribute('sameVoteCount'));
    _defineProperty(this, "teamPot1Count", Model.attribute('teamPot1Count'));
    _defineProperty(this, "teamPot2Count", Model.attribute('teamPot2Count'));
    _defineProperty(this, "teamPot3Count", Model.attribute('teamPot3Count'));
    _defineProperty(this, "teamPot4Count", Model.attribute('teamPot4Count'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "teamPot1", Model.hasOne('teamPot1'));
    _defineProperty(this, "teamPot2", Model.hasOne('teamPot2'));
    _defineProperty(this, "teamPot3", Model.hasOne('teamPot3'));
    _defineProperty(this, "teamPot4", Model.hasOne('teamPot4'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/MundialVote', MundialVote);